import React, { useState, useEffect } from 'react';
import { useGetUser, useSetUser } from '../../context/userContext';
import editUser from '../../api/editUser';

const Experience = () => {
  const user = useGetUser();
  const setUser = useSetUser();
  const [edit, setEdit] = useState(false);
  const [userCopy, setUserCopy] = useState(user);

  useEffect(() => {
    setUserCopy(user);
  }, [user]);

  return (
    <div className="row mycard">
      <div className="col col-12">
        {edit && <EditInfo userCopy={userCopy} setUserCopy={setUserCopy} user={user} setUser={setUser} setEdit={setEdit} />}
        <Info userCopy={userCopy} setUserCopy={setUserCopy} setUser={setUser} setEdit={setEdit} edit={edit} />
      </div>
    </div>
  );
};

export default Experience;

const Info = ({ userCopy, setUserCopy, setUser, setEdit, edit }) => {
  const handleRemoveExperience = (_id) => {
    const newUserCopy = { ...userCopy };
    let expArr = newUserCopy.experience;
    expArr = expArr.filter((el) => el._id !== _id);
    newUserCopy.experience = expArr;

    editUser(newUserCopy, setUser);
  };

  return (
    <>
      {!edit ? (
        <h2 className="heading">
          <span>Experience</span>
          <button className="btn btn-sm profile-btn" onClick={() => setEdit(true)}>
            <i className="bi bi-plus-circle"></i> Add new
          </button>
        </h2>
      ) : (
        <hr style={{ width: 'calc(100% + 24px)', margin: '0 -12px 15px -12px' }} />
      )}
      <div className="content mx-5">
        <div className="main hr">
          {userCopy.experience?.length === 0 && (
            <div className="col col-12">
              <span className="lead">No details has been provided yet.</span>
            </div>
          )}
          {userCopy.experience &&
            userCopy.experience.map((el) => (
              <div className="row" key={el._id}>
                <div className="col col-12 col-md-10 col-xl-11">
                  <p className="m-0">
                    <span className="lead">{el.position}</span>
                    <small>
                      <small className="text-mute ps-3">
                        {new Date(el.dateFrom).toLocaleDateString()} - {el.isPresent ? 'now' : new Date(el.dateTo).toLocaleDateString()}
                      </small>
                    </small>
                  </p>
                  <p style={{ opacity: '0.5' }}>
                    {el.companyName} <small>({el.location})</small>
                  </p>
                  <p>
                    <small style={{ whiteSpace: 'pre-line' }}>{el.duties}</small>
                  </p>
                </div>
                <div className="col col-md-2 col-xl-1 text-end">
                  <button type="button" className="btn btn-link del" onClick={() => handleRemoveExperience(el._id)}>
                    <i className="bi bi-trash"></i>
                  </button>
                </div>
              </div>
            ))}
        </div>
      </div>
    </>
  );
};

const EditInfo = ({ userCopy, setUserCopy, user, setUser, setEdit }) => {
  const [form, setForm] = useState({ position: '', location: '', companyName: '', dateFrom: new Date(), dateTo: new Date(), duties: '', isPresent: false });

  const handleSubmit = (e) => {
    e.preventDefault();

    const dateFrom = new Date(form.yearFrom, form.monthFrom, form.dayFrom);
    const dateTo = new Date(form.yearTo, form.monthTo, form.dayTo);

    const expObj = { ...form, dateFrom, dateTo };
    delete expObj.dayFrom;
    delete expObj.monthFrom;
    delete expObj.yearFrom;
    delete expObj.dayTo;
    delete expObj.monthTo;
    delete expObj.yearTo;

    const newUserCopy = { ...userCopy };
    const expArr = newUserCopy.experience;
    expArr.push(expObj);
    newUserCopy.experience = expArr;

    editUser(newUserCopy, setUser);
    setEdit(false);
  };

  const handleCancel = () => {
    setUserCopy(user);
    setEdit(false);
  };

  return (
    <>
      <h2 className="heading">
        Experience
        <span></span>
      </h2>
      <div className="content mx-5">
        <div className="main">
          <form className="row g-3" onSubmit={(e) => handleSubmit(e)}>
            <div className="col-12 col-md-12">
              <label htmlFor="inputPosition" className="form-label">
                Profession
              </label>
              <input
                type="text"
                className="form-control"
                id="inputPosition"
                placeholder="Profession"
                value={form.position}
                onChange={(e) =>
                  setForm((prev) => {
                    return { ...prev, position: e.target.value };
                  })
                }
              />
            </div>

            <div className="col-12 col-md-6">
              <label htmlFor="inputCompany" className="form-label">
                Company
              </label>
              <input
                type="text"
                className="form-control"
                id="inputCompany"
                placeholder="Company"
                value={form.companyName}
                onChange={(e) =>
                  setForm((prev) => {
                    return { ...prev, companyName: e.target.value };
                  })
                }
              />
            </div>

            <div className="col-12 col-md-6">
              <label htmlFor="inputLocation" className="form-label">
                Location
              </label>
              <input
                type="text"
                className="form-control"
                id="inputLocation"
                placeholder="Location"
                value={form.location}
                onChange={(e) =>
                  setForm((prev) => {
                    return { ...prev, location: e.target.value };
                  })
                }
              />
            </div>

            <div className="col-12 col-md-6">
              <label className="form-label">From date:</label>
              <div className="input-group mb-3">
                <input
                  type="number"
                  className="form-control"
                  placeholder="day"
                  aria-label="day"
                  value={form.dayFrom}
                  onChange={(e) =>
                    setForm((prev) => {
                      return { ...prev, dayFrom: e.target.value === '' ? '' : e.target.value < 1 ? 1 : e.target.value > 31 ? 31 : e.target.value };
                    })
                  }
                />
                <span className="input-group-text">-</span>
                <input
                  type="number"
                  className="form-control"
                  placeholder="month"
                  aria-label="month"
                  value={form.monthFrom + 1}
                  onChange={(e) =>
                    setForm((prev) => {
                      return { ...prev, monthFrom: e.target.value === '' ? '' : e.target.value < 1 ? 1 : e.target.value > 11 ? 11 : e.target.value - 1 };
                    })
                  }
                />
                <span className="input-group-text">-</span>
                <input
                  type="number"
                  className="form-control"
                  placeholder="year"
                  aria-label="year"
                  value={form.yearFrom}
                  onChange={(e) =>
                    setForm((prev) => {
                      return { ...prev, yearFrom: e.target.value === '' ? '' : e.target.value < 1 ? 1 : e.target.value > new Date().getFullYear() ? new Date().getFullYear() : e.target.value };
                    })
                  }
                />
              </div>
            </div>

            <div className="col-12 col-md-6">
              <label className="form-label">To date:</label>
              <div className="input-group mb-3">
                <input
                  type="number"
                  className="form-control"
                  placeholder="day"
                  aria-label="day"
                  value={form.dayTo}
                  onChange={(e) =>
                    setForm((prev) => {
                      return { ...prev, dayTo: e.target.value === '' ? '' : e.target.value < 1 ? 1 : e.target.value > 31 ? 31 : e.target.value };
                    })
                  }
                />
                <span className="input-group-text">-</span>
                <input
                  type="number"
                  className="form-control"
                  placeholder="month"
                  aria-label="month"
                  value={form.monthTo + 1}
                  onChange={(e) =>
                    setForm((prev) => {
                      return { ...prev, monthTo: e.target.value === '' ? '' : e.target.value < 1 ? 1 : e.target.value > 11 ? 11 : e.target.value - 1 };
                    })
                  }
                />
                <span className="input-group-text">-</span>
                <input
                  type="number"
                  className="form-control"
                  placeholder="year"
                  aria-label="year"
                  value={form.yearTo}
                  onChange={(e) =>
                    setForm((prev) => {
                      return { ...prev, yearTo: e.target.value === '' ? '' : e.target.value < 1 ? 1 : e.target.value > new Date().getFullYear() ? new Date().getFullYear() : e.target.value };
                    })
                  }
                />
              </div>
            </div>

            <div className="col-12" style={{ marginTop: '-5px' }}>
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="currentJob"
                  checked={form.isPresent}
                  onChange={(e) =>
                    setForm((prev) => {
                      return { ...prev, isPresent: !form.isPresent };
                    })
                  }
                />
                <label className="form-check-label ps-3" htmlFor="currentJob">
                  Current?
                </label>
              </div>
            </div>

            <div className="col-12 col-md-12 mt-4">
              <div className="form-floating">
                <textarea
                  className="form-control"
                  placeholder=""
                  id="floatingTextarea2"
                  style={{ height: '100px' }}
                  value={form.duties}
                  onChange={(e) => {
                    setForm((prev) => {
                      return { ...prev, duties: e.target.value };
                    });
                  }}
                />
                <label htmlFor="floatingTextarea2">What are the duties?</label>
              </div>
            </div>

            <div className="col-12 text-end">
              <button type="button" className="btn profile-btn inver mb-1" onClick={handleCancel}>
                Cancel
              </button>
              <button type="submit" className="btn profile-btn mb-1 ms-3">
                Save
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};
